import styled from "@emotion/styled";

export const CardsRow = styled.div<{ $columns?: boolean }>(({ theme, $columns }) => ({
  display: "flex",
  flexDirection: $columns ? "row" : "column",
  padding: $columns ? undefined : `${theme.spacing[2]} 0`,
  width: "100%",
  flexWrap: "wrap",
  gap: theme.spacing[5],
}));
